import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSogouComponent } from './simple-icons-sogou.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSogouComponent ],
    exports:      [ SimpleIconsSogouComponent ],
    bootstrap:    []
})
export class SimpleIconsSogouModule {}
